import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "CameraAction"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21.75 20.25C22.1642 20.25 22.5 19.9142 22.5 19.5V4.5C22.5 4.08579 22.1642 3.75 21.75 3.75H2.25C1.83579 3.75 1.5 4.08579 1.5 4.5V19.5C1.5 19.9142 1.83579 20.25 2.25 20.25H21.75ZM21 5.25V18.75H3V5.25H21ZM9 17.25C6.51472 17.25 4.5 15.2353 4.5 12.75C4.5 10.2647 6.51472 8.25 9 8.25C11.4853 8.25 13.5 10.2647 13.5 12.75C13.5 15.2353 11.4853 17.25 9 17.25ZM19.5 6.75H14.25V8.25H19.5V6.75ZM9 9.75C7.34315 9.75 6 11.0931 6 12.75C6 14.4069 7.34315 15.75 9 15.75C10.6569 15.75 12 14.4069 12 12.75C12 11.0931 10.6569 9.75 9 9.75ZM9.75 12.75C9.75 13.1642 9.41421 13.5 9 13.5C8.58579 13.5 8.25 13.1642 8.25 12.75C8.25 12.3358 8.58579 12 9 12C9.41421 12 9.75 12.3358 9.75 12.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/CameraAction.vue"]]);
